import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api/client';
import type { User } from '@/types/auth';

export const authKeys = {
  profile: () => ['auth', 'profile'] as const,
};

export const useAuth = ({ enabled = true }: { enabled?: boolean } = {}) => {
  // token is stored in localStorage
  const token = localStorage.getItem('token');

  return useQuery<User>({
    queryKey: authKeys.profile(),
    queryFn: async () => {
      const { data } = await apiClient.get('/auth/profile');
      return data;
    },
    enabled: enabled && !!token, // Only run query if enabled is true and token exists
  });
};
